(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSProyecto', SSProyecto);

    SSProyecto.$inject = ['$resource', 'DateUtils'];

    function SSProyecto ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-proyectos/:id';

        return $resource(resourceUrl, {}, {
            'query': { 
            	method: 'GET', 
            	url:'api/s-s-proyectos:idCentroDocente,:idProgramaEducativo,:fechaIniPer,:fechaFinPer,:estatusProyecto',
            	isArray: true
           	},
            'queryCurrentUser': { 
            	method: 'GET', 
            	url:'api/s-s-proyectos-current-user:idCentroDocente,:idProgramaEducativo,:fechaIniPer,:fechaFinPer,:estatusProyecto',
            	isArray: true
           	},
            'queryAlumno': { 
            	method: 'GET', 
            	url:'api/s-s-proyectos-alumno/:alumno',
            	isArray: true
           	},
            'queryAlumnoFacultad': { 
            	method: 'GET', 
            	url:'api/s-s-proyectos-alumno-fac/:alumno',
            	isArray: true
           	},
            'getByPrestador': { 
            	method: 'GET', 
            	url:'api/s-s-proyectos/prestador/:fechaIniPer,:fechaFinPer',
            	isArray: true
           	},
            'getByCentroDocente': { 
            	method: 'GET', 
            	url:'api/s-s-proyectos/centro-docente/:id',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.inicioVigencia = DateUtils.convertDateTimeFromServer(data.inicioVigencia);
                        data.finVigencia = DateUtils.convertDateTimeFromServer(data.finVigencia);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }           	
            },
           	'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.inicioVigencia = DateUtils.convertDateTimeFromServer(data.inicioVigencia);
                        data.finVigencia = DateUtils.convertDateTimeFromServer(data.finVigencia);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'getSolicitud': {
                method: 'GET',
            	url:'api/s-s-proyectos/:id/solicitud',                
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if(data.periodoInicial){
	                        data.periodoInicial.iniPeriodo = DateUtils.convertDateTimeFromServer(data.periodoInicial.iniPeriodo);
	                        data.periodoInicial.finPeriodo = DateUtils.convertDateTimeFromServer(data.periodoInicial.finPeriodo);
	                        data.periodoInicial.iniConvocatoria = DateUtils.convertDateTimeFromServer(data.periodoInicial.iniConvocatoria);
	                        data.periodoInicial.finConvocatoria = DateUtils.convertDateTimeFromServer(data.periodoInicial.finConvocatoria);
						}
                        data.inicioVigencia = DateUtils.convertDateTimeFromServer(data.inicioVigencia);
                        data.finVigencia = DateUtils.convertDateTimeFromServer(data.finVigencia);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'updateBySolicitante': { 
            	method:'PUT',
            	url:'api/s-s-proyectos/solicitante', 
            },
            'updateByAdministrativo': { 
            	method:'PUT',
            	url:'api/s-s-proyectos/administrativo', 
            },
            'deletePerfilBySolicitante': { 
            	method:'GET',
            	url:'api/s-s-proyectos/:sSProyecto/solicitante/:sSPerfil/delete', 
            },
            'deletePerfilByAdministrativo': { 
            	method:'GET',
            	url:'api/s-s-proyectos/:sSProyecto/administrativo/:sSPerfil/delete', 
            },
            'savePerfilBySolicitante': { 
            	method:'PUT',
            	url:'api/s-s-proyectos/solicitante/saveperfil', 
            },
            'savePerfilByAdministrativo': { 
            	method:'PUT',
            	url:'api/s-s-proyectos/administrativo/saveperfil', 
            },
            'updateVigencia': { 
            	method:'PUT',
            	url:'api/s-s-proyectos/:id/updateVigencia', 
            },
            'register': { 
            	method:'PUT',
            	url:'api/s-s-proyectos/registro',                
            	},
            'save': { method:'POST' },
            'getProyAproAnteriormente': { 
            	method:'GET',
            	url:'api/s-s-proyectos/getProyAproAnteriormente/:id',       
            	transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
